var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c("div", { staticClass: "row bg-white padding-flex mb-1" }, [
        _c("div", { staticClass: "container box-full pr-0" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              [
                _vm.$root.is_mobile
                  ? _c(
                      "div",
                      { staticClass: "d-flex align-items-center w-100" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-9 col-md-11 pl-0 estate-price" },
                          [
                            _c("span", {
                              staticClass: "current-price",
                              domProps: { innerHTML: _vm._s(_vm.estate.price) }
                            }),
                            _vm._v(" "),
                            _vm.estate.price_alternative
                              ? _c("span", {
                                  staticClass: "current-price-euro",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.estate.price_alternative
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("estate-discount", {
                              attrs: { estate: _vm.estate }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("estate-actions", { attrs: { estate: _vm.estate } }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "share-button" },
                          [
                            _c("estate-share", {
                              attrs: {
                                estate: _vm.estate,
                                "estate-id": _vm.estate.id,
                                "agency-id": _vm.estate.agency
                                  ? _vm.estate.agency.id
                                  : null,
                                type: _vm.estate.ad_type
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$root.is_mobile
                  ? _c(
                      "div",
                      { staticClass: "col-xl-9 col-lg-9 col-md-8 pl-0" },
                      [
                        _c("h1", { staticClass: "estate-title" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.estate.title) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "estate-subtitle" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.estate.subtitle) +
                              "\n                    "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$root.is_mobile
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xl-3 col-lg-3 col-md-4 estate-actions"
                      },
                      [
                        [
                          _c("estate-actions", {
                            attrs: { estate: _vm.estate }
                          })
                        ],
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "share-button" },
                          [
                            _c("estate-share", {
                              attrs: {
                                estate: _vm.estate,
                                "estate-id": _vm.estate.id,
                                "agency-id": _vm.estate.agency
                                  ? _vm.estate.agency.id
                                  : null,
                                type: _vm.estate.ad_type
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.$root.is_mobile
                          ? _c("div", { staticClass: "ref" }, [
                              _vm._v(
                                _vm._s(_vm.lang.details.ref) +
                                  ": " +
                                  _vm._s(_vm.estate.id)
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.costs && _vm.estate.costs.mortgage_payment_value
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col p-0 hipotecas" },
                  [
                    _c(
                      "modal-opener",
                      {
                        staticClass: "calculate-mortgage",
                        attrs: { name: "calculate-mortgage" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.lang.labels.hipotecas.replace(
                                ":value",
                                _vm.estate.costs.mortgage_payment_value
                              )
                            )
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 p-0" }, [
              !_vm.$root.is_mobile
                ? _c(
                    "div",
                    { staticClass: "estate-price" },
                    [
                      _c("span", {
                        staticClass: "current-price",
                        domProps: { innerHTML: _vm._s(_vm.estate.price) }
                      }),
                      _vm._v(" "),
                      _vm.estate.price_alternative
                        ? _c("span", {
                            staticClass: "current-price-euro",
                            domProps: {
                              innerHTML: _vm._s(_vm.estate.price_alternative)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("estate-discount", { attrs: { estate: _vm.estate } })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-xl-7 p-0" },
                [
                  _vm.$root.is_mobile
                    ? _c("div", [
                        _c("h1", { staticClass: "estate-title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.estate.title) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "estate-subtitle" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.estate.subtitle) +
                              "\n                        "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("estate-card-data", { attrs: { estate: _vm.estate } })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$root.is_mobile && _vm.estate.pdf
                ? _c("div", { staticClass: "text-left" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-network print-pdf",
                        attrs: {
                          href: _vm.estate.pdf,
                          target: "_blank",
                          rel: "nofollow"
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.trans("labels.print")) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container box-sticky" }, [
          _c("div", { staticClass: "row" }, [
            _vm.$root.is_mobile
              ? _c("div", { staticClass: "d-flex align-items-center w-100" }, [
                  _c(
                    "div",
                    { staticClass: "col-9 estate-price" },
                    [
                      _c("span", {
                        staticClass: "current-price",
                        domProps: { innerHTML: _vm._s(_vm.estate.price) }
                      }),
                      _vm._v(" "),
                      _vm.estate.price_alternative
                        ? _c("span", {
                            staticClass: "current-price-euro",
                            domProps: {
                              innerHTML: _vm._s(_vm.estate.price_alternative)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("estate-discount", { attrs: { estate: _vm.estate } })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-xl-3 col-lg-4" }, [
              _c("h1", { staticClass: "estate-title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.estate.title) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "estate-subtitle" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.estate.subtitle) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "estate-fix" },
                [_c("estate-card-data", { attrs: { estate: _vm.estate } })],
                1
              )
            ]),
            _vm._v(" "),
            !_vm.$root.is_mobile
              ? _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "div",
                    { staticClass: "estate-price" },
                    [
                      _c("span", {
                        staticClass: "current-price",
                        domProps: { innerHTML: _vm._s(_vm.estate.price) }
                      }),
                      _vm._v(" "),
                      _vm.estate.price_alternative
                        ? _c("span", {
                            staticClass: "current-price-euro",
                            domProps: {
                              innerHTML: _vm._s(_vm.estate.price_alternative)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("estate-discount", { attrs: { estate: _vm.estate } })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-auto col-lg-auto estate-actions ml-auto" },
              [
                _c("estate-actions", { attrs: { estate: _vm.estate } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "share-button" },
                  [
                    _c("estate-share", {
                      attrs: {
                        estate: _vm.estate,
                        "estate-id": _vm.estate.id,
                        "agency-id": _vm.estate.agency
                          ? _vm.estate.agency.id
                          : null,
                        type: _vm.estate.ad_type
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-auto col-lg-auto estate-actions contactar ml-1"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-network mt-1",
                    on: { click: _vm.contact }
                  },
                  [_vm._v(_vm._s(_vm.lang.details.contact))]
                )
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }